export default __webpack_public_path__ + "static/media/products-banner-img.c309d1ec.avif";